export const MuiLinearProgress = {
  styleOverrides: {
    barColorPrimary: {
      backgroundColor: '#000',
    },
  },
}
